import React from 'react';
import styled from 'styled-components';
import { string, oneOfType, array, object, number } from 'prop-types';
import { get, isNil } from 'lodash';
import Title from './Title';
import Text from './Text';

const ColRow = styled.td`
`;

const Table = ({ title, headers, body, counter, style }) => {
    const titleFlex = !isNil(counter) ? { display: 'flex' } : {};
    return (
        <div style={style}>
            <div style={{ borderBottom: '2px solid #333333', lineHeight: '2.7', ...titleFlex }}>
                { title && <Title text={title} /> }
                { !isNil(counter) && <Title text={`${counter}`} style={{ justifyContent: 'flex-end', flex: 0 }} /> }
            </div>
            <table style={{ width: '100%' }}>
                <thead style={{ borderBottom: '1px solid #eaeaea' }}>
                    <tr>
                        { headers.map(({ key, value }, indexHeader) => (
                            <td key={`${key}-${indexHeader}`}>
                                <div style={{ padding: '7px' }}>
                                    <Text text={value} semibold />
                                </div>
                            </td>
                        )) }
                    </tr>
                </thead>
                <tbody>
                    {
                        body.map((item, index) => {
                            return (
                                <tr key={index} style={item.rowStyle || { borderBottom: '1px solid #eaeaea' }}>
                                    {
                                        headers.map(({ key }, indexBody) => {
                                            const style = get(item, 'style', {});
                                            return (
                                                <ColRow key={indexBody} style={style}>
                                                    { typeof item[key] === 'function' ? (item[key])() : (
                                                        <div style={{ padding: '7px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            <Text inherit text={item[key] || null} />
                                                        </div>
                                                    )}
                                                </ColRow>
                                            );
                                        })
                                    }
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

Table.propTypes = {
    title: string,
    headers: oneOfType([array, object]),
    body: oneOfType([array, object]),
    counter: oneOfType([() => null, number]),
    style: object
};

Table.defaultProps = {
    title: null,
    headers: [],
    body: [],
    counter: null,
    style: {}
};

export default Table;
